import React, { useContext } from "react";
import MainSelect from "components/MainSelect/MainSelect.view";
import { useStyles } from "./RCAAPComplianceFilters.styles";
import { RCAAPComplianceRangeEnum } from "../../../RCAAPComplianceInterfaces";
import useRCAAPComplianceFilters from "./useRCAAPComplianceFilters";
import { Box, InputLabel, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import RCAMeetingTypesDropdown from "pages/Corporate/RCA/components/RCAMeetingTypesDropdown/RCAMeetingTypesDropdown";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import { RCAAPComplianceContext } from "contexts/RCAAPComplianceContext/RCAAPComplianceContext";
import DefaultFiltersButton from "pages/Corporate/RCA/components/DefaultFiltersButton/DefaultFiltersButton";

const rcaComplianceRangeValues = Object.values(RCAAPComplianceRangeEnum);

const RCAAPComplianceFilters = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const mainClasses = useRCAMainStyles();
    const {
        filters,
        handleSetFilters,
        handleSetMeetingTypes,
        loadingDefaultOperations,
        isFiltersDefault,
        handleRemoveDefaultFilters,
        handleSetFiltersDefault,
        userFiltersDefault,
    } = useContext(RCAAPComplianceContext);
    const { rcaComplianceOptions } = useRCAAPComplianceFilters({ rcaComplianceRangeOptions: rcaComplianceRangeValues });

    return (
        <div className={classes.select}>
            <Box>
                <InputLabel>
                    <Typography variant="subtitle2" className={mainClasses.contentFormLabel}>
                        {t("rca.rca_library.rca_detail.meeting_type")}
                    </Typography>
                </InputLabel>
                <RCAMeetingTypesDropdown
                    multiple
                    notSelectedOption
                    value={filters.meetingTypeIds}
                    handleOnComponentMount={(meetingTypeIds) => {
                        handleSetMeetingTypes(meetingTypeIds as number[], meetingTypeIds.length);
                    }}
                    onChange={(values) => {
                        handleSetMeetingTypes(values as number[]);
                    }}
                />
            </Box>
            <MainSelect
                fullWidth={false}
                multiple={false}
                value={filters.periodOption}
                options={rcaComplianceOptions || []}
                onChange={(e) => handleSetFilters(e.target.value as number)}
            />
            <DefaultFiltersButton
                isDefault={isFiltersDefault}
                loading={loadingDefaultOperations}
                hasUserDefault={!!userFiltersDefault}
                onRemoveDefault={handleRemoveDefaultFilters}
                onSaveOrUpdate={() => handleSetFiltersDefault(filters)}
                variant="contained"
                color="info"
                className={mainClasses.contentButton}
            />
        </div>
    );
};

export default RCAAPComplianceFilters;
